import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'

import injectRole from '../../components/HOC/injectRole'
import { TRoles, TRoutes } from '../../shared/const'

import CourseReport from '../../components/views/admin/CourseReport'

/*
 * Kurs-Auswertung — Landes- und Bundesverwaltung. Die Landesbetreuung sieht
 * nur ihr Bundesland; das grenzt der Server ein. Alumni nicht: Die Liste
 * nennt Schüler:innen mit Namen und Ergebnissen.
 */
function CourseReportPage(props) {
	if (props.role === TRoles.ADMIN || props.role === TRoles.FEDERAL_ADMIN) return <CourseReport />
	return <Redirect to={TRoutes.DASHBOARD} />
}

CourseReportPage.propTypes = { role: PropTypes.string.isRequired }

export default injectRole(CourseReportPage)
